"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var functions_1 = require("../_common/functions");
var _setupAjax = function ($) {
    /**
     * Default Ajax overridable behaviour
     */
    $.ajaxSetup({
        error: function (xhr) {
            bootbox.alert((0, functions_1.getErrorMessage)(xhr));
        },
    });
    var ajaxWrapper = function (url, settings) {
        var hasRedirect = function (jqXHR) {
            return jqXHR.responseJSON !== undefined && jqXHR.responseJSON.redirect !== undefined;
        };
        // wrapper for "success" handler
        var originalSuccessHandler = settings.success;
        settings.success = function (data, textStatus, jqXHR) {
            if (hasRedirect(jqXHR)) {
                window.location.href = jqXHR.responseJSON.redirect;
            }
            else if (originalSuccessHandler) {
                originalSuccessHandler.apply(this, arguments);
            }
        };
        // wrapper for "complete" handler
        var originalCompleteHandler = settings.complete;
        settings.complete = function (jqXHR, textStatus) {
            // Trigger the local "complete" handler only if there was no redirect
            if (!hasRedirect(jqXHR) && originalCompleteHandler) {
                originalCompleteHandler.apply(this, arguments);
            }
        };
        // CSRF wrapping
        var _csrfSafeMethod = function (method) {
            // these HTTP methods do not require CSRF protection
            return /^(GET|HEAD|OPTIONS)$/.test(method);
        };
        var originalBeforeSendHandler = settings.beforeSend;
        settings.beforeSend = function (jqXHR, ajaxSettings) {
            if (!_csrfSafeMethod(ajaxSettings.type) && !this.crossDomain) {
                var csrfToken = getCookie('csrf_token');
                if (csrfToken) {
                    jqXHR.setRequestHeader('X-CSRF-Token', csrfToken);
                }
            }
            if (originalBeforeSendHandler) {
                originalBeforeSendHandler.apply(this, arguments);
            }
        };
        // Return the original $.ajax return value
        return originalAjax.apply(this, [url, settings]);
    };
    var originalAjax = $.ajax;
    $.ajax = function (url, settings) {
        // Ajax method overloading
        if (typeof url === 'object') {
            return ajaxWrapper(undefined, url);
        }
        else {
            return ajaxWrapper(url, settings);
        }
    };
};
exports.default = _setupAjax;
